import React, { Component } from 'react';
import ScheduleInterviewView from './ScheduleInterviewView';
import { url } from '../../../Server/url/GlobalUrl';
import Moment from 'moment';



class ScheduleInterviewComponent extends Component {
	state = {
        email: '',
		password: '',
		authResponse:'',
		modal_show: false,
		custom_model: false,
		first_name:'',
		last_name:'',
		date: '',
		time: '',

	}
	componentDidMount() {
        localStorage.removeItem("schedule-interview");
	    let data_refresh = {'refresh': localStorage.getItem('refresh')}
                    fetch(url + '/api/token/refresh/', {
                method: 'POST',
                headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data_refresh)
            })
                .then((response) => {
                 if (response['status'] === 201 || response['status'] === 200) {
                    return response.json()
                } else if (response['status'] === 401) {
                    this.showCustomModal()
                    this.setState({authResponse:'Some Thing went wrong'})
                    localStorage.removeItem('refresh')
                    localStorage.removeItem('access')
                    localStorage.removeItem('is_admin')
                }
                })
                .then((result) => {
                    if (result){
                    console.log('result.access',result.access)
                    localStorage.setItem('token',result.access)
                    }
                }
                )
	            fetch((url + "/api/current/?token="+ localStorage.getItem("invalid")), {
                method: 'GET'
                })
              .then(res => res.json())
              .then(
                (result) => {
                    if (result.length > 0){
                  console.log('result',result, result[0].first_name)
                  this.setState({ first_name: result[0].first_name })
                  this.setState({ last_name: result[0].last_name })
                  console.log('asdasd',this.state.first_name)
                  localStorage.setItem('cv-id',result.id)
              }
                },
                (error) => {
                  console.log('error',error)
                })
	}

    hideCustomModal = () => {
        this.setState({ modal_show: false })
        if(this.state.authResponse.slice(0,3) == "You"){
            window.location.replace('/registrations/form2')
        }
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }


    handelData  = (identity,data) =>{
    	console.log('hello')
        var d = new Date();
        var d1 = new Date(this.state.date);
    	if (identity === 'time'){
            if(this.sameDay(d,d1)){
                if(d.getHours() >= data.slice(0,2)){
                    this.showCustomModal();
                    this.setState({authResponse:"Please select the correct time"});
                    return;
                }
                else{
                    this.hideCustomModal();
                }
            }
            console.log('time',data)
            this.setState({'time' : data})
        }

    }
    sameDay = (d1, d2) =>{
          return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }
    handleLangChange = (identity,data) => {
        if (identity === 'start_date'){
            console.log('start_date',data)
            var date = Moment(data).format('YYYY-MM-DD')
            this.setState({ date: date })
        }
    }
    handelSummit = () =>{


        console.log('handelsubmit')
        console.log('date',this.state.date)
        console.log('time',this.state.time)
        let form_data = new FormData();
        let auth = localStorage.getItem("token")
        form_data.append('interview_date', this.state.date);
        form_data.append('interview_time', this.state.time);
        fetch(url + '/api/v1/user/submit-details/' + localStorage.getItem('cv-id') + '/', {
        method: 'PUT',
        headers:{
            'Authorization': 'Bearer ' + auth,
        },
        body: form_data
        })
        .then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200) {
                
                this.showCustomModal()
				this.setState({authResponse:'Your Interview Scheduled Successfully'})
                return response.json()
            } else if (response['status'] === 400) {
                this.showCustomModal()
				this.setState({authResponse:'Please check the validations above'})
                return response.json()
            }
        })
        .then((result) => {console.log('result',result)

        })
        .catch(error => {
            console.log(error)
        });

    }


    render() {
        if(!localStorage.getItem("token")){
        window.location.replace("/login/?next=/schedule-interview/")
        }
        return (<ScheduleInterviewView
                handelSummit = {this.handelSummit}
				handelData = {this.handelData}
                time = {this.state.time}
				handleLangChange= {(identity,date) => this.handleLangChange(identity,date)}
				authResponse = {this.state.authResponse}
				modal_show = {this.state.modal_show}
				hideCustomModal = {this.hideCustomModal}
        		custom_model = {this.state.custom_model}
        	/>)
    }
}

export default ScheduleInterviewComponent;